import { CardContent, Typography } from '@mui/material';

export const AdvicesCard = ({ title, text, textTemp }) => {
    return (
        <CardContent>
            <Typography variant='h5' component='div' sx={{ marginBottom: '6px' }}>
                {title}
            </Typography>
            <Typography
                variant='body2'
                sx={{
                    fontSize: '18px',
                    '@media screen and (max-width: 650px)': { fontSize: '1rem' }
                }}>
                {text} {textTemp}
            </Typography>
        </CardContent>
    )
}